"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ADD_PRODUCTS_TO_BASKET_RESULT_DIALOG = void 0;
const ADD_PRODUCTS_TO_BASKET_RESULT_DIALOG = exports.ADD_PRODUCTS_TO_BASKET_RESULT_DIALOG = 'add-products-to-basket-result-dialog';
